import useAccessControl from '../../legacy/components/AccessControl/useAccessControl'
import clientEnv from '../../utils/global/clientEnv'

// Feature toggle name - defined as const for reusability
const PRIVACY_CONSENT_MANAGEMENT_TOGGLE = 'rt_ipp_cookie_consent_management'

/**
 * Hook to check if privacy compliance features are enabled
 *
 * This hook checks for the privacy domain consent management feature toggle
 * that enables OneTrust cookie banner and other privacy compliance features.
 *
 * @returns {boolean} Whether privacy compliance features are enabled
 */
export const usePrivacyComplianceAccess = (): boolean => {
  const hasAccess = useAccessControl()

  const hasFeatureToggle = hasAccess({
    featureToggles: PRIVACY_CONSENT_MANAGEMENT_TOGGLE as any,
  })

  // TODO: Remove this after proper Roulette configuration
  // For local development, enable if environment variable is set
  const localOverride =
    clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'local' &&
    !!clientEnv.PUBLIC_CLIENT_ONETRUST_DOMAIN_UUID

  return hasFeatureToggle || localOverride
}

/**
 * Hook specifically for OneTrust cookie banner access
 *
 * @returns {boolean} Whether OneTrust cookie banner should be displayed
 */
export const useOneTrustAccess = (): boolean => usePrivacyComplianceAccess()

export default usePrivacyComplianceAccess
